import { c as _c } from "react/compiler-runtime";
import IconDeferred from '@/assets/icons/heroIcons/Deferred-payment.svg';
import IconThird from '@/assets/icons/heroIcons/Icon-third.svg';
import IconCard from '@/assets/icons/heroIcons/Card-front.svg';
import IconWarranty from '@/assets/icons/heroIcons/Warranty.svg';
import Mini from '@/assets/icons/heroIcons/Mini.svg';
import Maxi from '@/assets/icons/heroIcons/Maxi.svg';
import IconInstallments from '@/assets/icons/heroIcons/Installments.svg';
import IconExtend from '@/assets/icons/heroIcons/Extend.svg';
import IconPayment from '@/assets/icons/heroIcons/Payment.svg';
import IconLoan from '@/assets/icons/heroIcons/Loan.svg';
import IconChevronRight from '@/assets/icons/heroIcons/Chevron-right.svg';
import IconTulip from '@/assets/icons/heroIcons/Tulip.svg';
import IconDiscount from '@/assets/icons/heroIcons/Discount.svg';
import { FilledButton } from '@/components/buttons';
import React, { PropsWithChildren } from 'react';
import { useTranslation } from 'react-i18next';
import { EXTERNAL_LINKS, LINKS } from '@/constants/links';
import { Text, Headline } from '@/components/typography';
import { Link } from '@/components/links';
import { showSpringOffer } from '@/utils/springOffer';
interface BoxProps {
  icon: React.JSX.Element;
  title: string;
  subtitle?: string;
  text: string;
  footer?: React.JSX.Element;
  badge?: string;
  className?: string;
}
function Box(props) {
  const $ = _c(25);
  const t0 = `relative h-full w-full rounded-2xl bg-white px-8 py-8 md:rounded-4xl md:py-10 ${props.className ?? ""}`;
  let t1;
  if ($[0] !== props.badge) {
    t1 = props.badge && <span className="absolute top-0 right-8 z-10 -translate-y-1/2 rounded-full bg-blue-500 px-4 py-1 text-xs font-semibold text-white">{props.badge}</span>;
    $[0] = props.badge;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== props.icon) {
    t2 = <div className="shrink-0 text-blue-500">{props.icon}</div>;
    $[2] = props.icon;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  if ($[4] !== props.title) {
    t3 = <Headline as="h2" variant="h4" className="text-2xl font-bold lg:text-3xl">{props.title}</Headline>;
    $[4] = props.title;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  let t4;
  if ($[6] !== t2 || $[7] !== t3) {
    t4 = <div className="mb-4 flex flex-row items-center gap-4">{t2}{t3}</div>;
    $[6] = t2;
    $[7] = t3;
    $[8] = t4;
  } else {
    t4 = $[8];
  }
  let t5;
  if ($[9] !== props.text) {
    t5 = <Text variant="p3" className="mb-8 text-gray-800">{props.text}</Text>;
    $[9] = props.text;
    $[10] = t5;
  } else {
    t5 = $[10];
  }
  let t6;
  if ($[11] !== props.subtitle) {
    t6 = props.subtitle ? <Text variant="p3" className="mb-4 font-semibold">{props.subtitle}</Text> : null;
    $[11] = props.subtitle;
    $[12] = t6;
  } else {
    t6 = $[12];
  }
  let t7;
  if ($[13] !== props.children) {
    t7 = <div className="-mx-2 flex flex-col gap-2">{props.children}</div>;
    $[13] = props.children;
    $[14] = t7;
  } else {
    t7 = $[14];
  }
  let t8;
  if ($[15] !== props.footer) {
    t8 = props.footer && <div className="mt-6">{props.footer}</div>;
    $[15] = props.footer;
    $[16] = t8;
  } else {
    t8 = $[16];
  }
  let t9;
  if ($[17] !== t0 || $[18] !== t1 || $[19] !== t4 || $[20] !== t5 || $[21] !== t6 || $[22] !== t7 || $[23] !== t8) {
    t9 = <div className={t0}>{t1}{t4}{t5}{t6}{t7}{t8}</div>;
    $[17] = t0;
    $[18] = t1;
    $[19] = t4;
    $[20] = t5;
    $[21] = t6;
    $[22] = t7;
    $[23] = t8;
    $[24] = t9;
  } else {
    t9 = $[24];
  }
  return t9;
}
export function ProductBoxes() {
  const $ = _c(142);
  const {
    t
  } = useTranslation("ourProducts");
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = showSpringOffer();
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  const shouldShowSpringOffer = t0;
  let t1;
  if ($[1] !== t) {
    t1 = t("products.title");
    $[1] = t;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  let t2;
  if ($[3] !== t1) {
    t2 = <Headline as="h1" id="products" variant="h1" className="mb-13 text-center text-2xl font-bold text-white lg:text-3xl">{t1}</Headline>;
    $[3] = t1;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  let t3;
  if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = <Mini className="h-12 w-12" />;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  let t4;
  if ($[6] !== t) {
    t4 = t("products.mini.title");
    $[6] = t;
    $[7] = t4;
  } else {
    t4 = $[7];
  }
  let t5;
  if ($[8] !== t) {
    t5 = t("products.mini.text");
    $[8] = t;
    $[9] = t5;
  } else {
    t5 = $[9];
  }
  let t6;
  let t7;
  if ($[10] === Symbol.for("react.memo_cache_sentinel")) {
    t6 = <IconDeferred className="h-7 w-7" />;
    t7 = LINKS();
    $[10] = t6;
    $[11] = t7;
  } else {
    t6 = $[10];
    t7 = $[11];
  }
  const t8 = t7.deferredPayment;
  let t9;
  if ($[12] !== t) {
    t9 = t("products.deferredPayment.title");
    $[12] = t;
    $[13] = t9;
  } else {
    t9 = $[13];
  }
  let t10;
  if ($[14] !== t9) {
    t10 = {
      icon: t6,
      to: t8,
      testId: "ourProductsTableDeferredPayment",
      analyticsParam: "ourProductsTableDeferredPayment",
      title: t9
    };
    $[14] = t9;
    $[15] = t10;
  } else {
    t10 = $[15];
  }
  let t11;
  let t12;
  if ($[16] === Symbol.for("react.memo_cache_sentinel")) {
    t11 = <IconThird className="h-7 w-7" />;
    t12 = LINKS();
    $[16] = t11;
    $[17] = t12;
  } else {
    t11 = $[16];
    t12 = $[17];
  }
  const t13 = t12.payInThree;
  let t14;
  if ($[18] !== t) {
    t14 = t("products.payInThree.title");
    $[18] = t;
    $[19] = t14;
  } else {
    t14 = $[19];
  }
  let t15;
  if ($[20] !== t14) {
    t15 = {
      icon: t11,
      to: t13,
      testId: "ourProductsTablePayInThree",
      analyticsParam: "ourProductsTablePayInThree",
      title: t14
    };
    $[20] = t14;
    $[21] = t15;
  } else {
    t15 = $[21];
  }
  let t16;
  let t17;
  if ($[22] === Symbol.for("react.memo_cache_sentinel")) {
    t16 = <IconLoan className="h-7 w-7" />;
    t17 = LINKS();
    $[22] = t16;
    $[23] = t17;
  } else {
    t16 = $[22];
    t17 = $[23];
  }
  const t18 = t17.loan;
  let t19;
  if ($[24] !== t) {
    t19 = t("products.loan.title");
    $[24] = t;
    $[25] = t19;
  } else {
    t19 = $[25];
  }
  let t20;
  if ($[26] !== t19) {
    t20 = {
      icon: t16,
      to: t18,
      testId: "ourProductsTableLoan",
      analyticsParam: "ourProductsTableLoan",
      title: t19
    };
    $[26] = t19;
    $[27] = t20;
  } else {
    t20 = $[27];
  }
  let t21;
  let t22;
  if ($[28] === Symbol.for("react.memo_cache_sentinel")) {
    t21 = <IconWarranty className="h-7 w-7" />;
    t22 = LINKS();
    $[28] = t21;
    $[29] = t22;
  } else {
    t21 = $[28];
    t22 = $[29];
  }
  const t23 = t22.insuranceAndWarranty;
  let t24;
  if ($[30] !== t) {
    t24 = t("products.warranty.title");
    $[30] = t;
    $[31] = t24;
  } else {
    t24 = $[31];
  }
  let t25;
  if ($[32] !== t24) {
    t25 = {
      icon: t21,
      to: t23,
      testId: "ourProductsTableWarranty",
      analyticsParam: "ourProductsTableWarranty",
      title: t24
    };
    $[32] = t24;
    $[33] = t25;
  } else {
    t25 = $[33];
  }
  let t26;
  let t27;
  if ($[34] === Symbol.for("react.memo_cache_sentinel")) {
    t26 = <IconDiscount className="h-7 w-7" />;
    t27 = EXTERNAL_LINKS();
    $[34] = t26;
    $[35] = t27;
  } else {
    t26 = $[34];
    t27 = $[35];
  }
  const t28 = t27.cashback;
  let t29;
  if ($[36] !== t) {
    t29 = t("products.cashback.title");
    $[36] = t;
    $[37] = t29;
  } else {
    t29 = $[37];
  }
  let t30;
  if ($[38] !== t29) {
    t30 = {
      icon: t26,
      to: t28,
      testId: "ourProductsTableCashback",
      analyticsParam: "ourProductsTableCashback",
      title: t29
    };
    $[38] = t29;
    $[39] = t30;
  } else {
    t30 = $[39];
  }
  let t31;
  if ($[40] !== t10 || $[41] !== t15 || $[42] !== t20 || $[43] !== t25 || $[44] !== t30) {
    t31 = [t10, t15, t20, t25, t30].map(_temp);
    $[40] = t10;
    $[41] = t15;
    $[42] = t20;
    $[43] = t25;
    $[44] = t30;
    $[45] = t31;
  } else {
    t31 = $[45];
  }
  let t32;
  if ($[46] !== t31 || $[47] !== t4 || $[48] !== t5) {
    t32 = <Box icon={t3} title={t4} text={t5}>{t31}</Box>;
    $[46] = t31;
    $[47] = t4;
    $[48] = t5;
    $[49] = t32;
  } else {
    t32 = $[49];
  }
  let t33;
  if ($[50] === Symbol.for("react.memo_cache_sentinel")) {
    t33 = <Maxi className="h-12 w-12" />;
    $[50] = t33;
  } else {
    t33 = $[50];
  }
  let t34;
  if ($[51] !== t) {
    t34 = t("products.revolving.title");
    $[51] = t;
    $[52] = t34;
  } else {
    t34 = $[52];
  }
  let t35;
  if ($[53] !== t) {
    t35 = t("products.revolving.text");
    $[53] = t;
    $[54] = t35;
  } else {
    t35 = $[54];
  }
  let t36;
  if ($[55] !== t) {
    t36 = t("products.favourite");
    $[55] = t;
    $[56] = t36;
  } else {
    t36 = $[56];
  }
  let t37;
  if ($[57] === Symbol.for("react.memo_cache_sentinel")) {
    t37 = LINKS();
    $[57] = t37;
  } else {
    t37 = $[57];
  }
  const t38 = t37.revolving;
  let t39;
  if ($[58] !== t) {
    t39 = t("products.revolving.cta");
    $[58] = t;
    $[59] = t39;
  } else {
    t39 = $[59];
  }
  let t40;
  if ($[60] === Symbol.for("react.memo_cache_sentinel")) {
    t40 = <IconChevronRight className="h-5 w-5" />;
    $[60] = t40;
  } else {
    t40 = $[60];
  }
  let t41;
  if ($[61] !== t39) {
    t41 = <Link to={t38} analyticsParam="revolvingCTA" testId="revolvingCTA"><div className="flex flex-row items-center">{t39}{t40}</div></Link>;
    $[61] = t39;
    $[62] = t41;
  } else {
    t41 = $[62];
  }
  let t42;
  let t43;
  if ($[63] === Symbol.for("react.memo_cache_sentinel")) {
    t42 = <IconDeferred className="h-7 w-7" />;
    t43 = LINKS();
    $[63] = t42;
    $[64] = t43;
  } else {
    t42 = $[63];
    t43 = $[64];
  }
  const t44 = t43.deferredPayment;
  let t45;
  if ($[65] !== t) {
    t45 = t("products.deferredPayment.title");
    $[65] = t;
    $[66] = t45;
  } else {
    t45 = $[66];
  }
  let t46;
  if ($[67] !== t45) {
    t46 = {
      icon: t42,
      to: t44,
      testId: "ourProductsTableDeferredPayment",
      analyticsParam: "ourProductsTableDeferredPayment",
      title: t45
    };
    $[67] = t45;
    $[68] = t46;
  } else {
    t46 = $[68];
  }
  let t47;
  let t48;
  if ($[69] === Symbol.for("react.memo_cache_sentinel")) {
    t47 = <IconThird className="h-7 w-7" />;
    t48 = LINKS();
    $[69] = t47;
    $[70] = t48;
  } else {
    t47 = $[69];
    t48 = $[70];
  }
  const t49 = t48.payInThree;
  let t50;
  if ($[71] !== t) {
    t50 = t("products.payInThree.title");
    $[71] = t;
    $[72] = t50;
  } else {
    t50 = $[72];
  }
  let t51;
  if ($[73] !== t50) {
    t51 = {
      icon: t47,
      to: t49,
      testId: "ourProductsTablePayInThree",
      analyticsParam: "ourProductsTablePayInThree",
      title: t50
    };
    $[73] = t50;
    $[74] = t51;
  } else {
    t51 = $[74];
  }
  let t52;
  let t53;
  if ($[75] === Symbol.for("react.memo_cache_sentinel")) {
    t52 = <IconDiscount className="h-7 w-7" />;
    t53 = EXTERNAL_LINKS();
    $[75] = t52;
    $[76] = t53;
  } else {
    t52 = $[75];
    t53 = $[76];
  }
  const t54 = t53.cashback;
  let t55;
  if ($[77] !== t) {
    t55 = t("products.cashback.title");
    $[77] = t;
    $[78] = t55;
  } else {
    t55 = $[78];
  }
  let t56;
  if ($[79] !== t55) {
    t56 = {
      icon: t52,
      to: t54,
      testId: "ourProductsTableCashback",
      analyticsParam: "ourProductsTableCashback",
      title: t55
    };
    $[79] = t55;
    $[80] = t56;
  } else {
    t56 = $[80];
  }
  let t57;
  let t58;
  if ($[81] === Symbol.for("react.memo_cache_sentinel")) {
    t57 = <IconLoan className="h-7 w-7" />;
    t58 = LINKS();
    $[81] = t57;
    $[82] = t58;
  } else {
    t57 = $[81];
    t58 = $[82];
  }
  const t59 = t58.loan;
  let t60;
  if ($[83] !== t) {
    t60 = t("products.loan.title");
    $[83] = t;
    $[84] = t60;
  } else {
    t60 = $[84];
  }
  let t61;
  if ($[85] !== t60) {
    t61 = {
      icon: t57,
      to: t59,
      testId: "ourProductsTableLoan",
      analyticsParam: "ourProductsTableLoan",
      title: t60
    };
    $[85] = t60;
    $[86] = t61;
  } else {
    t61 = $[86];
  }
  let t62;
  let t63;
  if ($[87] === Symbol.for("react.memo_cache_sentinel")) {
    t62 = <IconWarranty className="h-7 w-7" />;
    t63 = LINKS();
    $[87] = t62;
    $[88] = t63;
  } else {
    t62 = $[87];
    t63 = $[88];
  }
  const t64 = t63.insuranceAndWarranty;
  let t65;
  if ($[89] !== t) {
    t65 = t("products.warranty.title");
    $[89] = t;
    $[90] = t65;
  } else {
    t65 = $[90];
  }
  let t66;
  if ($[91] !== t65) {
    t66 = {
      icon: t62,
      to: t64,
      testId: "ourProductsTableWarranty",
      analyticsParam: "ourProductsTableWarranty",
      title: t65
    };
    $[91] = t65;
    $[92] = t66;
  } else {
    t66 = $[92];
  }
  let t67;
  let t68;
  if ($[93] === Symbol.for("react.memo_cache_sentinel")) {
    t67 = <IconCard className="h-7 w-7" />;
    t68 = LINKS();
    $[93] = t67;
    $[94] = t68;
  } else {
    t67 = $[93];
    t68 = $[94];
  }
  const t69 = t68.card;
  let t70;
  if ($[95] !== t) {
    t70 = t("products.card.title");
    $[95] = t;
    $[96] = t70;
  } else {
    t70 = $[96];
  }
  let t71;
  if ($[97] !== t70) {
    t71 = {
      icon: t67,
      to: t69,
      testId: "ourProductsTableCard",
      analyticsParam: "ourProductsTableCard",
      title: t70
    };
    $[97] = t70;
    $[98] = t71;
  } else {
    t71 = $[98];
  }
  let t72;
  let t73;
  if ($[99] === Symbol.for("react.memo_cache_sentinel")) {
    t72 = <IconInstallments className="h-7 w-7" />;
    t73 = LINKS();
    $[99] = t72;
    $[100] = t73;
  } else {
    t72 = $[99];
    t73 = $[100];
  }
  const t74 = t73.installments;
  let t75;
  if ($[101] !== t) {
    t75 = t("products.installments.title");
    $[101] = t;
    $[102] = t75;
  } else {
    t75 = $[102];
  }
  let t76;
  if ($[103] !== t75) {
    t76 = {
      icon: t72,
      to: t74,
      testId: "ourProductsTableInstallment",
      analyticsParam: "ourProductsTableInstallment",
      title: t75
    };
    $[103] = t75;
    $[104] = t76;
  } else {
    t76 = $[104];
  }
  let t77;
  let t78;
  if ($[105] === Symbol.for("react.memo_cache_sentinel")) {
    t77 = <IconExtend className="h-7 w-7" />;
    t78 = LINKS();
    $[105] = t77;
    $[106] = t78;
  } else {
    t77 = $[105];
    t78 = $[106];
  }
  const t79 = t78.postponeDueDate;
  let t80;
  if ($[107] !== t) {
    t80 = t("products.postponeDueDate.title");
    $[107] = t;
    $[108] = t80;
  } else {
    t80 = $[108];
  }
  let t81;
  if ($[109] !== t80) {
    t81 = {
      icon: t77,
      to: t79,
      testId: "ourProductsTablePostponeDueDate",
      analyticsParam: "ourProductsTablePostponeDueDate",
      title: t80
    };
    $[109] = t80;
    $[110] = t81;
  } else {
    t81 = $[110];
  }
  let t82;
  let t83;
  if ($[111] === Symbol.for("react.memo_cache_sentinel")) {
    t82 = <IconPayment className="h-7 w-7" />;
    t83 = LINKS();
    $[111] = t82;
    $[112] = t83;
  } else {
    t82 = $[111];
    t83 = $[112];
  }
  const t84 = t83.bankTransfer;
  let t85;
  if ($[113] !== t) {
    t85 = t("products.bankTransfer.title");
    $[113] = t;
    $[114] = t85;
  } else {
    t85 = $[114];
  }
  let t86;
  if ($[115] !== t85) {
    t86 = {
      icon: t82,
      to: t84,
      testId: "ourProductsTableBankTransfer",
      analyticsParam: "ourProductsTableBankTransfer",
      title: t85
    };
    $[115] = t85;
    $[116] = t86;
  } else {
    t86 = $[116];
  }
  let t87;
  if ($[117] !== t) {
    t87 = shouldShowSpringOffer ? [{
      icon: <IconTulip className="h-7 w-7" />,
      to: LINKS().youShopWePay,
      testId: "ourProductsTableSpringPromo",
      analyticsParam: "ourProductsTableSpringPromo",
      title: t("products.revolving.springPromo.title")
    }] : [];
    $[117] = t;
    $[118] = t87;
  } else {
    t87 = $[118];
  }
  let t88;
  if ($[119] !== t46 || $[120] !== t51 || $[121] !== t56 || $[122] !== t61 || $[123] !== t66 || $[124] !== t71 || $[125] !== t76 || $[126] !== t81 || $[127] !== t86 || $[128] !== t87) {
    t88 = [t46, t51, t56, t61, t66, t71, t76, t81, t86, ...t87].map(_temp2);
    $[119] = t46;
    $[120] = t51;
    $[121] = t56;
    $[122] = t61;
    $[123] = t66;
    $[124] = t71;
    $[125] = t76;
    $[126] = t81;
    $[127] = t86;
    $[128] = t87;
    $[129] = t88;
  } else {
    t88 = $[129];
  }
  let t89;
  if ($[130] !== t34 || $[131] !== t35 || $[132] !== t36 || $[133] !== t41 || $[134] !== t88) {
    t89 = <Box icon={t33} title={t34} text={t35} badge={t36} footer={t41}>{t88}</Box>;
    $[130] = t34;
    $[131] = t35;
    $[132] = t36;
    $[133] = t41;
    $[134] = t88;
    $[135] = t89;
  } else {
    t89 = $[135];
  }
  let t90;
  if ($[136] !== t32 || $[137] !== t89) {
    t90 = <div className="flex w-full flex-col-reverse flex-wrap items-center justify-center gap-4 p-4 md:flex-row md:items-baseline md:gap-8 [&>*]:max-w-106">{t32}{t89}</div>;
    $[136] = t32;
    $[137] = t89;
    $[138] = t90;
  } else {
    t90 = $[138];
  }
  let t91;
  if ($[139] !== t2 || $[140] !== t90) {
    t91 = <div className="mx-auto flex max-w-292 flex-col gap-4 md:gap-8">{t2}{t90}</div>;
    $[139] = t2;
    $[140] = t90;
    $[141] = t91;
  } else {
    t91 = $[141];
  }
  return t91;
}
function _temp2(item_0, key_0) {
  return <FilledButton key={key_0} {...item_0} className="w-full! shadow-none" variant="sm">{item_0.title}</FilledButton>;
}
function _temp(item, key) {
  return <FilledButton key={key} {...item} className="w-full! shadow-none" variant="sm">{item.title}</FilledButton>;
}